import Logo from "../components/Logo"
import Card from "../components/Card"
import Failed from "../assets/failed-gif.gif"

function PaymentFailed() {
   
  return (
    <div className="login-container">
    <Logo/>
    <Card>
        <div className="img-group">
            <img src={Failed} alt="failed" />
        </div>
    <h4 className="card-head text-danger"> 
    Payment failed!
    </h4>
    <div className="banner failed-banner"></div>
    <p className="card-text">
    You are now being redirected to the Payment page.
    </p>
   
    </Card>
    
</div>
  )
}

export default PaymentFailed